import { Group } from '@jupiterone/jupiter-web-toolkit';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import styles from '../AccountPage.styles';
import LazyLoadList from '../AccountPageList/LazyLoadList';
import GroupDetail from './GroupDetail/GroupDetail';
import useGroups, { GroupsProvider } from '../../hooks/useGroups';
import { InvitationProvider } from '../../hooks/usePendingSentInvitations';
import { RelevantPoliciesProvider } from '../../hooks/useRelevantPolicies';

const useStyles = makeStyles(styles);

const UsersAccessPage = () => {
  const classes = useStyles();
  const { groups, createGroup } = useGroups();
  const [selectedGroupId, setSelectedGroupId] = useState<string | undefined>(
    undefined
  );
  const [activeTab, setActiveTab] = useState<number>(0);

  const selectGroup = (id: Group['id'] | undefined, tab: number) => {
    setSelectedGroupId(id);
    setActiveTab(tab);
  };

  const selectNewGroup = async () => {
    const { id } = await createGroup();
    setSelectedGroupId(id);
  };

  const selectedGroup = selectedGroupId
    ? groups.find(({ id }) => id === selectedGroupId)
    : undefined;
  if (!selectedGroup) {
    return (
      <div className={classes.fadeIn}>
        <LazyLoadList
          titleText="Your Groups"
          addText="Add Group"
          onSelect={selectGroup}
          onAdd={selectNewGroup}
        />
      </div>
    );
  }

  return (
    <div className={classes.fadeIn}>
      <GroupDetail
        classes={classes}
        handleBackButton={() => selectGroup(undefined, 0)}
        handleTabChange={setActiveTab}
        group={selectedGroup}
        tab={activeTab}
      />
    </div>
  );
};
const WrappedUsersAccessPage = () => {
  return (
    <GroupsProvider>
      <InvitationProvider>
        <RelevantPoliciesProvider>
          <UsersAccessPage />
        </RelevantPoliciesProvider>
      </InvitationProvider>
    </GroupsProvider>
  );
};

export { UsersAccessPage };

export default WrappedUsersAccessPage;
